<template>
    <div>
        <el-radio-group :value="value" @input="$emit('input',$event)" v-if="options.length>0">
            <el-radio v-for="item in options" :key="item.Time" :label="item.Time" :disabled="item.Used>=item.Count">{{item.Time}}({{item.Used}}/{{item.Count}})</el-radio>
        </el-radio-group>
        <div v-else>请选择院区</div>
    </div>
</template>
<script>
    export default {
        name: "radioTime",
        props: {
            value: {
                type: [String, Number,]
            },
            hospital_id: {
                required: true
            },
            department_id: {
                required: true
            },
            doctor_id: {
                required: true
            },
            date: {
                required: true
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            hospital_id(newVal) {
                this.getData()
            },
            department_id(){
                this.getData()
            },
            doctor_id(){
                this.getData()
            },
            date(){
                this.getData()
            }
        },
        data() {
            return {
                options: []
            }
        },
        methods: {
            async getData() {
                if (this.hospital_id && this.department_id && this.doctor_id && this.date) {
                    const resp = await this.$http.get(`/mingde/worksheet/getTimes?hospital_id=${this.hospital_id}&department_id=${this.department_id}&doctor_id=${this.doctor_id}&date=${this.date}`)
                    console.log(resp)
                    this.options = resp.data.data || []
                }
            }
        },
        mounted() {
            this.getData()
        }
    };
</script>
<style lang="scss" scoped>
</style>
